module.exports = __webpack_public_path__ + "img/clogo.4da61716.png";